import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../components/card/Card";

import { getPosts, selectPosts } from "../features/posts/postsSlice";

export default function HomeScreen() {
  const dispatch = useDispatch();

  const posts = useSelector(selectPosts);

  useEffect(() => {
    dispatch(getPosts(""));
  }, [dispatch]);

  return (
    <div>
      {posts.map((outerEl) =>
        outerEl.data.children.map((post) => (
          <Card key={post.data.id} post={post} className="card" />
        ))
      )}
    </div>
  );
}
